angular
.module('jv.candidate.send.video.modal.controller',[])
.controller('CandDetailsSendVideoModalCtrl', ['$scope', '$routeParams', '$rootScope', 'videoService', '$timeout', '$window', '$q', '$log', '$jobviteUrls', 'appDetailsService', '$filter', 'jvTotango', 'currentUserService',
function($scope, $routeParams, $rootScope, videoService, $timeout, $window, $q, $log, $jobviteUrls, appDetailsService,$filter, jvTotango, currentUserService) {
    var responseObject = {};
    $scope.isNewJQuery = parseFloat(jQuery.fn.jquery) > 1.7;
    $scope._currentUser = $window._jvselfUser;
    //TODO: Temporary variables till we consolidate API's.
    $scope.triggeredFromCandidateListAdHoc = false;
    $scope.triggeredFromDetailsPage = false;
    $scope.appIds = [];
    $scope.videoFormResponseId =null;

    $scope.datePickerOptions = {
        minDate: $rootScope.getTodayDateUserTimezone(),
        saveFormat: 'mm/dd/yy'
    };

    $scope.cancelRequest = function() {
        $rootScope.$broadcast('showVideoModalResult');
        $scope.hideModals();
    };

    $scope.$on('hidingVideoModals', function(e, val) {
        $scope.cleanModal();
    });

    /*
     * TODO-PRANAV: Copying this from jv.ReqsNotesCtrl.js beacuse Candidate Details Page is using
     * Angular 1.0.1 and setPristine is available in 1.1.* onwards. Once we upgrade will not need this code.
     * So dont want to invest time in making code resuable etc.
     * This function makes the form pristine(setting to initial state of the form).
     */
    var makePristine = function(formCtrl, elem) {
        var name;
        if (formCtrl && formCtrl.$name) {
            name = $filter('uppercase')(formCtrl.$name.charAt(0)) + formCtrl.$name.substr(1);
            if (elem) {
                // new version of angular has $setPristine, use when available
                if (formCtrl.$setPristine) {
                    formCtrl.$setPristine();
                } else {
                    elem.removeClass('ng-dirty').addClass('ng-pristine');
                    formCtrl.$pristine = true;
                    formCtrl.$dirty = false;
                    angular.forEach(elem.find('.ng-dirty'), function(el) {
                        var inputCtrl = $(el).data('$ngModelController');
                        if (!inputCtrl) {
                            return;
                        }
                        inputCtrl.$pristine = true;
                        inputCtrl.$dirty = false;
                        $(el).removeClass('ng-dirty').addClass('ng-pristine');
                    });
                }
            }
        }
    };

    $scope.questionnaireHasError = function() {
        return $scope.submitted && $scope.VideoInterviewForm.questionnaire.$error.select2Invalid;
    };

    $scope.cleanModal = function() {
        $scope.videoFormResponseId =null;
        $scope.questionID = "";
        $scope.submitted = false;
        $scope.vidTemplates = {};
        $scope.responseObject = {};
        //VA: Do not change it to {}
        $scope.responseObject.response = null;
        $scope.responseObject.expiryDate = "";
        $scope.hideQuestionnaireSelectionRow = false;
        $scope.ifQuestionnaireSelectionDisabled = false;
        //VA: Do not change the counts to 0;
        $scope.invalidCount = null;
        $scope.validCount = null;
        $scope.agencyCount = null;
        makePristine($scope.VideoInterviewForm, $('form[name="VideoInterviewForm"]'));
        $scope.grantExtensionModalType = false;
    };

    $scope.cleanModal();

    $scope.previewQuestionnaire = function() {
        $scope.$emit('previewQuestionnaire', $scope.questionID);
        if (angular.isUndefined($scope.lazyLoading.videoPreviewTemplateUrl)) {
            $scope.lazyLoading.videoPreviewTemplateUrl = $jobviteUrls.video + "/video/recruiter/previewVideoInterviewModal.html";
        }
    };

    $scope.$watch('questionID', function(value) {
        if (value === "") {
            $scope.VideoInterviewForm.questionnaire.$setValidity("select2Invalid", false);
        } else {
            $scope.VideoInterviewForm.questionnaire.$setValidity("select2Invalid", true);
        }
    });

    $scope.checkIfReadyToShow = function() {
        if ($scope.responseObject.response !== null && $scope.responseObject.response && $scope.vidTemplates.messageTemplates) {
            $rootScope.$broadcast("VIDEO_REMOVE_LOADING");
            $scope.modal.sendVideo = true;
            if ($scope.flags) {
                $scope.flags.loading = false;
            }
        }
    };

    function validateApplications(args) {
        $rootScope.$broadcast("VIDEO_SHOW_LOADING");
        var defer = $q.defer();
        videoService.validateApplications({
            "applicationEIds": args.appIds,
            "adhoc": args.adhoc
        }, function(result) {
            $rootScope.$broadcast("VIDEO_REMOVE_LOADING");
            defer.resolve(result);
        });
        return defer.promise;
    }

    $scope.$on('showVideoModalAdHoc', function(event, value) {
        value.adhoc = true;
        var promise = validateApplications(value);
        promise.then(function(result) {
            value.validations = result;
            value.appIds = result.validIds;
            //This is temporary, till we test out new API.
            $scope.triggeredFromCandidateListAdHoc = true;
            if (!fillVideoModalObjectsFromApplicantListDataHelper(value)) {
                return;
            }
            showVideoModalHelper(false, null, null, $scope.appIds);
        }, function() {
            // TODO: Operation could not be performed.
        });
    });

    $scope.$on('showVideoModalForWorkflow', function(event, value) {
        value.adhoc = false;
        // This flag tops the ifQuestionnaireSelectionDisabled.
        var promise = validateApplications(value);
        promise.then(function(result) {
            value.validations = result;
            value.appIds = result.validIds;
            //$scope.hideQuestionnaireSelectionRow = true;
            $scope.ifQuestionnaireSelectionDisabled = true;
            if (!fillVideoModalObjectsFromApplicantListDataHelper(value)) {
                return;
            }
            $scope.appIds = value.appIds;
            $scope.workflowRelated = true;

            var workflowObj = {}
            workflowObj.stateId = value.stateId;
            workflowObj.workflowStateKind = value.workflowStateKind;

            showVideoModalHelper(false, workflowObj, value.jobEId, $scope.appIds);
        }, function() {
            // TODO: Operation could not be performed.
        });
    });


    function fillVideoModalObjectsFromApplicantListDataHelper(value) {
        fillValidationValues(value);
        if ($scope.validCount === 0) {
            $rootScope.$broadcast("SHOW_VIDEO_QUESTIONNAIRE_ERROR_MODAL_FROM_CANDIDATE_LIST", $scope.validInvalidSum);
            return false;
        }
        $scope.appIds = value.appIds;
        // If name is present, just assign it.
        $scope.applicantName = value.name;
        //If only one application is present then send one application Id, else send an array
        if (value.appIds.length === 1) {
            $scope.singleApplicant = true;
        } else {
            $scope.singleApplicant = false;
        }
        return true;
    }

    // inserts the values in the scope for validations, and agency counts etc.
    function fillValidationValues(value){
        $scope.invalidCount = value.validations.invalidCount;
        $scope.validCount = value.validations.validCount;
        $scope.validInvalidSum = $scope.invalidCount + $scope.validCount;
        $scope.agencyCount = value.validations.agencyCount;
        $scope.responseObject.expiryDate = value.validations.expirationDate;
    }
    /**
     * TODO: Pranav: Refactor this code. Currently this is being called for all candidate details use case
     *  This should be broken down, so that only workflow case is handled here.
     *  vfrId: is only used for grant extension from the video list page.
     */
    $scope.$on('showVideoModal', function(event, isContact, appId, workflowObject, ifGeneralApplication, jobEId, vfrId, deadline) {
        $scope.grantExtentionModalType = false;
        //grant extension modal.
        if(vfrId!=undefined && vfrId!=null){
            $scope.grantExtentionModalType = true;
            $scope.videoFormResponseId =vfrId;
        }
        var value = {};
        value.appIds = [];

        //VA: We also need to check if there is a workflow stateId but the application is in a "general application" it has to be sent as adhoc.
        if (workflowObject && angular.isDefined(workflowObject) && !ifGeneralApplication) {
            value.adhoc = false;
        } else {
            value.adhoc = true;
        }

        // This gets called when we have grant extension modal to popup. We don't need to do the validations for email or questionnaire as the interview is an extension.
        // the same function gets called when all the validations are done and everything is validated. Moving it to common reusable code.
        var _callback = function(){
            $scope.applicantName = appDetailsService.getApplicantName();
            $scope.appIds[0] = appId;
            //Since this event is used only for candidate details use case, it is for single application.
            $scope.singleApplicant = true;
            //Will be called even for contactDetails usecase.
            $scope.triggeredFromDetailsPage = true;
            // showVideoModalHelper(workflowStateId, workflowStateKind, formResponseId, $scope.appDetails.application.job.EId, $scope.appIds);
            if($scope.grantExtentionModalType){
                showVideoModalHelper(isContact, workflowObject, jobEId, $scope.appIds, true);

            }else{
                showVideoModalHelper(isContact, workflowObject, jobEId, $scope.appIds);
            }
        }

        // Grand extension.
        if($scope.grantExtentionModalType){
            // we do not want to show the questionnaire.
            value.appIds.push($routeParams.applicationId);
            var promise = validateApplications(value);
            promise.then(function(result){
                fillValidationValues({
                    validations: result
                });
                if(deadline !== undefined && deadline !== null) {
                    var date = new Date(deadline);
                    date.setDate(date.getDate() + 1);
                    $scope.responseObject.expiryDate = $filter('date')(date, 'MM/dd/yyyy');;
                    $scope.datePickerOptions.minDate = date;
                }

                $scope.hideQuestionnaireSelectionRow = true;
                _callback();
            });
        }else{
        //Everything else.
            //VA: applicationId should be passed through a service instead of reading from the route params
            value.appIds.push($routeParams.applicationId);
            var promise = validateApplications(value);
            promise.then(function(result) {
                fillValidationValues({
                    validations: result
                });
                if (result.validCount === 0) {
                    if(result.emailUnknown){
                        $rootScope.$broadcast("SHOW_VIDEO_QUESTIONNAIRE_ERROR_MODAL", {
                            emailUnknown: true
                        });
                    }else{
                        $rootScope.$broadcast("SHOW_VIDEO_QUESTIONNAIRE_ERROR_MODAL");
                    }

                    if ($scope.flags) {
                        $scope.flags.loading = false;
                    }
                } else {
                    _callback();
                }
            }, function() {
                //Call failed.
            });
        }
    });


    var _workflowStateId;
    var _formResponseId;
    var _workflowStateKind;

    /**
     * VideoModalHelper function called to fetch questionnaires and templates and then show modal.
     * @param  Boolean isContact     Where this function is called for contacts or candidates use case.
     * @param  Object workflowObject Object which has all the details about the workflow.
     * @param  String jobEId         JobEId for the application selected.
     * @param  String applicationId  ApplicationId for the application selected.
     * @return None
     */
    var showVideoModalHelper = function(isContact, workflowObject, jobEId, applicationId, grantExtension) {
        $scope.isContact = isContact;
        if (workflowObject) {
            _formResponseId = workflowObject.formResponseId;
            _workflowStateId = workflowObject.stateId;
            _workflowStateKind = workflowObject.workflowStateKind;
        }else{
            _formResponseId = null;
            _workflowStateId = null;
            _workflowStateKind = null;
        }

        //VA: The removing of modal will happen in the checkifreadytoshow.
        $rootScope.$broadcast("VIDEO_SHOW_LOADING");

        $scope.ifQuestionnaireSelectionDisabled = false;
        if ($scope.hideQuestionnaireSelectionRow) {
            $scope.responseObject.response = {};
            $scope.checkIfReadyToShow();
        } else {
            var _callback = function(res) {
                $timeout(function() {
                    if (workflowObject) {
                        if (res.resultList.length === 1) {
                            $scope.questionID = res.resultList[0].SId;
                            $scope.ifQuestionnaireSelectionDisabled = true;
                        }
                        if (res.resultList.length === 0) {
                            // Show the error modal
                            $rootScope.$broadcast("SHOW_VIDEO_QUESTIONNAIRE_ERROR_MODAL");
                            if ($scope.flags) {
                                $scope.flags.loading = false;
                            }
                            return;
                        }
                    }
                    $scope.responseObject.response = res;
                    $scope.checkIfReadyToShow();
                }, 1);
            }

            //VA: it must be passed if the interview invite is sent from the video workflow step. It will be undefined if it is sent as an ad-hoc interview step.
            videoService.getQuestionnaires({
                "maxResults": 100,
                "page": 0,
                "workflowStateKind": _workflowStateKind, //VID-ENGAGE: Do we always need this ? No.
                "jobEId": jobEId,
                "active": true
            }, function(res) {
                if (res !== undefined) {
                    //VA: FF is having issues without timeout. Doesnt select the default entry otherwise.
                    _callback(res);
                }
            });
        }
        var args = {};
        if(grantExtension) {
            args.grantExtension = true;
        }
        args.applications = applicationId;

        videoService.getMessageTemplates($scope.isContact, args, function(res) {
            var templates = [];
            res.resultList = $scope.select2Options.setTemplates(res.resultList);
            angular.forEach(res.resultList, function(template) {
                if (template['default']) {
                    $scope.vidTemplates = $scope.vidTemplates || {};
                    $scope.vidTemplates.messageTpl = template;
                    $scope.content = template.body;
                    $scope.subject = template.subject;
                }
                templates.push(template);
            });
            $scope.vidTemplates.messageTemplates = templates;
            $scope.checkIfReadyToShow();
        });
    };

    $scope.sendVideoInterviewMessage = function() {
        //VA: it must be passed if the interview invite is sent from the video workflow step. It will be undefined if it is sent as an ad-hoc interview step.
        var videoForm = {};
        videoForm.questionID = $scope.questionID;
        videoForm.subject = $scope.subject;
        videoForm.message = $scope.content;
        videoForm.expirationDate = $scope.responseObject.expiryDate;

        videoForm.applicationEIds = $scope.appIds.join(',');
        videoForm.workflowStateId = _workflowStateId;
        videoForm.formResponseId = _formResponseId;
        var data = '',
            queryString = {
                value: ''
            },
            temp,
            sendToAgency = false,
            to = [];

        if ($scope.hideQuestionnaireSelectionRow) {
            var errorCounter = 0;
            for (var key in $scope.VideoInterviewForm) {
                if (key.indexOf('$') != 0 && $scope.VideoInterviewForm[key].$valid === false) {
                    errorCounter += 1;
                }
            }
            if (errorCounter > 1) {
                // Only one error that will be for the questionnaire.
                return;
            }
        } else if ($scope.VideoInterviewForm.$invalid) {
            return;
        }

        /*This is to escape the special characters */
        var formContent = encodeURIComponent(videoForm.content);
        var formSubject = encodeURIComponent(videoForm.subject);

        /*BE expects locale to be sent to determine language for Email header/footer*/
        if($scope.vidTemplates && $scope.vidTemplates.messageTpl){
            videoForm['locale'] = $scope.vidTemplates.messageTpl['locale'];
        }
        //VID-ENGAGE: Loading mechanism has to change.
        if ($scope.loading) {
            $scope.flags.loading = true;
        }

        $rootScope.$broadcast("VIDEO_SHOW_LOADING");
        // call back after the interview invite sent.
        var _callback = function(data) {
            $rootScope.$broadcast("VIDEO_REMOVE_LOADING");
            if (data.status === "ok") {
                $scope.modal.sendVideo = false;
                $scope.cleanModal();
                //FIX-IT: Damn we have too much dependance on jhire stuff. Difficult to reuse in
                //Engage. This is good, so we will make our stuff reusable and applicant independent.
                if (data.response && 'VIDEO_INVITE_STATUS_INVITE_SENT'===data.response && angular.isDefined($scope.showMsg)) {
                    $scope.showMsg('JV_CAND_DETAILS_SENDVIDEOMODAL_VIDEO_INTERVIEW_SENT');
                    $rootScope.$broadcast('showVideoModalResult', true);
                } else if (data.response && 'VIDEO_INVITE_STATUS_INVITE_SENT'!= data.response) {
                    $rootScope.error = i18n[data.response];
                } else {
                    $rootScope.$broadcast('showVideoModalResult', false);
                }
            } else {
                $rootScope.$broadcast('showVideoModalResult', false);
            }
            // hide the loading and remove the modal.
            if ($scope.loading) {
                $scope.flags.loading = false;
            }
            $scope.hideModals();
        };

        //TODO: Once we consolidate API's, this can be cleaned up tremendously.
        // One for AdHoc and one for Workflow. Dont need 3 variations then.

        //Grant extension modal
        if($scope.grantExtentionModalType){
            videoForm.vfrId = $scope.videoFormResponseId;
            delete videoForm.formResponseId;
            delete videoForm.workflowStateId;
            delete videoForm.questionId;
            videoService.grantExtension(videoForm, _callback)
        } else
        // if its a reinviting candidate
        if ( !! _formResponseId) {
            videoService.reinviteCandidate(videoForm, _callback);
            // Single Ad-Hoc Interview (from Details Page)
        } else if ($scope.triggeredFromDetailsPage) {
            jvTotango.track('Send Video Interview', jvTotango.module.video);
            videoService.sendVideoInterview($scope.isContact, videoForm, _callback);
            // Send Single Ad-Hoc or Multiple Interviews (workflow related)
        } else if ($scope.workflowRelated) {
            jvTotango.track('Send Video Interview', jvTotango.module.video);
            videoService.inviteWorkflowInterview(videoForm, _callback);
            // If triggered from Candidate List. Will be consolidated
        } else if ($scope.triggeredFromCandidateListAdHoc) {
            jvTotango.track('Send Video Interview', jvTotango.module.video);
            videoService.inviteAdHocInterview(videoForm, _callback);
        }else{
            // atlast if no condition is met (shouldn't happen) then remove the loading so user is not stuck.
            $rootScope.$broadcast("VIDEO_REMOVE_LOADING");
        }
    };
}]);